export default __webpack_public_path__ + "53200beb8f8efd41631f359d72cdca0b.png";